// extracted by mini-css-extract-plugin
export default {"preparingIllustration":"JM9YsPl15qecTV7moQYY","preparingIllustrationImage":"sneQVrfQgFBpNPfIhoAC","readyBadge":"eomzE8njGC143quiNnvK"};